export const clsx = (...classes) => {
  return classes
    .filter(Boolean)
    .map((className) => className.trim())
    .join(" ");
};
